<template>
  <div
    v-if="menuVisible != ''"
    class="menu-left"
    :class="{
      'open-sm': openSm,
      'min-md': minMenu || showRightWindow,
      mobile: menuVisible == 'mobile'
    }"
  >
    <MenuBox
      v-if="menuVisible == 'filter' || menuVisible == 'mobile'"
      title="Filtry"
      @clickButtonMenu="clickMinMenu"
    >
      <template slot="icon">
        <menu-icon />
      </template>

      <div class="mobile-menu">
        <ul>
          <li @click="goToAccount()">
            <div class="micon">
              <account-icon title="Moje konto" />
            </div>
            <span class="text">Moje konto</span>
          </li>
          <li @click="logout()">
            <div class="micon">
              <power-icon title="Wyloguj" class="micon" />
            </div>
            <span class="text">Wyloguj</span>
          </li>
        </ul>
      </div>

      <MenuBoxItem title="Kategorie" name="category" :open="true">
        <template slot="icon" class="menu-left-icon">
          <file-tree-icon />
        </template>
        <CategoryJsTree />
      </MenuBoxItem>
      <MenuBoxItem title="Producenci" name="brands" :open="true">
        <template slot="icon">
          <tag-outline-icon />
        </template>
        <BrandsCheckBox />
      </MenuBoxItem>

      <div v-for="filter in search.builtFilters">
        <MenuBoxItem :title="filter.name" :name="filter.name" :open="false">
          <template slot="icon">
            <filter-icon />
          </template>
          <AttributesCheckBox :filter="filter" />
        </MenuBoxItem>
      </div>
    </MenuBox>

    <MenuBox
      v-if="menuVisible == 'account'"
      title="Moje konto"
      @clickButtonMenu="clickMinMenu"
    >
      <template slot="icon">
        <menu-icon />
      </template>
      <AccountMenu />
    </MenuBox>
  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import { storeEmitter } from "../../state/store";
import MenuIcon from "vue-material-design-icons/Menu.vue";
import AccountIcon from "vue-material-design-icons/Account.vue";
import PowerIcon from "vue-material-design-icons/Power.vue";

import MenuBox from "./../layout/src/navigation/MenuBox.vue";
import MenuBoxItem from "./../layout/src/navigation/MenuBoxItem.vue";
import CategoryJsTree from "./../categories/src/CategoryJsTree.vue";
import BrandsCheckBox from "./../brands/src/BrandsCheckBox.vue";
import AttributesCheckBox from "./../layout/src/input/AttributesCheckBox.vue";
import AccountMenu from "./../account/src/account/AccountMenu.vue";

import FileTreeIcon from "vue-material-design-icons/FileTree.vue";
import TagOutlineIcon from "vue-material-design-icons/TagOutline.vue";
import FilterIcon from "vue-material-design-icons/Filter.vue";

export default {
  components: {
    FilterIcon,
    TagOutlineIcon,
    FileTreeIcon,
    MenuBox,
    MenuBoxItem,
    MenuIcon,
    CategoryJsTree,
    BrandsCheckBox,
    AttributesCheckBox,
    AccountMenu,
    AccountIcon,
    PowerIcon
  },
  data() {
    return {
      openSm: false,
      minMenu: false,
      scrollY: false
    };
  },
  computed: {
    ...mapState({
      search: state => state.search,
      showRightWindow: state => state.showRightWindow,
      menuVisible: state => state.menuVisible
    })
  },

  methods: {
    handleScroll() {
      this.scrollY = window.scrollY;
    },
    clickMinMenu() {
      if (this.showRightWindow) {
        this.$store.dispatch("closeRightWindow");
        this.minMenu = false;
      } else {
        this.minMenu = !this.minMenu;
      }
      storeEmitter.emit("on-click-min-menu", this.minMenu);
    },
    goToAccount() {
      this.$router.replace({ name: "account" });
    },

    async logout() {
      await this.$store.dispatch("user/signout");
      this.$router.go("/");
    }
  },

  beforeMount() {
    this.scrollY = window.scrollY;
  },

  mounted() {
    storeEmitter.on("open-sm", () => (this.openSm = !this.openSm));
    storeEmitter.on("close-sm", () => (this.openSm = false));
  },

  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/template/MenuLeft.vue